import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import _notification from 'modules/notification';
import { Card, Table, Modal, Icon } from 'antd';
import EmptyState from 'components/enterprise/EmptyState';
import PageHeader from 'components/enterprise/PageHeader';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import ButtonComponent from 'components/controls/Button';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';

class SpecializationMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 10, current: 1 },
            highlightedRowID: 0,
            data: [],
            degree: [],
            rowData: {},
            loading: false,
            showModel: false,
            showMessageBox: false,
            categoryError: "",
            degreeError: "",
            totalRowCount: 0,
        };
    }

    componentDidMount() {
        this.getAllSpecialization();
        this.getAllDegree();
    }

    //API operations
    getAllSpecialization = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let specializationList = await _AdminService.GetAllSpecialization();
                    //console.log("categoryList Data: ", specializationList.data);

                    this.setState({
                        ...this.state,
                        data: specializationList.data,
                        totalRowCount: specializationList.data.length,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllDegree = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let degreeList = await _AdminService.GetAllDegree();
                    //console.log("categoryList Data: ", degreeList.data);

                    this.setState({
                        ...this.state,
                        degree: degreeList.data ? degreeList.data.map(item => ({ Id: item.Id, Name: item.Qualification_Name })) : [],
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleUpdate = async (input) => {
        if (this.validateFormData()) {
            return
        }

        const params = {
            Qualification_Name: this.state.rowData.Qualification_Name.trim(),
            Qualification_Specilisation: this.state.rowData.Qualification_Specilisation,
            ParentId: this.state.rowData.ParentId,
            Id: this.state.rowData.Id
        }

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.CreateSpecialization(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        _notification.showMessage('success', "Specialization saved successfully.");
                        this.setState({
                            categoryError: "",
                            degreeError: "",
                            showModel: false,
                            loading: false,
                            highlightedRowID: params.Id
                        });
                        this.getAllSpecialization();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    deletePost = async (value) => {
        const params = {
            Name: this.state.rowData.Name,
            Id: this.state.rowData.Id
        }

        //console.log("Final data: ", params);
        try {
            const response = await _AdminService.DeleteSpecialization(this.state.rowData.Id);
            //console.log("Post response: ", response);
            if (response.status == 200 && response.data.IsSuccess) {
                _notification.showMessage('success', "Specialization deleted successfully.");
                this.setState({
                    categoryError: "",
                    degreeError: "",
                    showModel: false
                });
                this.getAllSpecialization();
            }
            else {
                _notification.showMessage('error', response.data.Message);
            }
        } catch (e) {
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    }

    //Table action link clicks
    onEditClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showModel: true, highlightedRowID: 0 });
    };

    onDeleteClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showMessageBox: true, highlightedRowID: 0 });
    };

    onTableAction = (pagination, filters, sorter, extra) => {
        //console.log('onTableAction ', pagination,'onFilter ', filters, sorter, extra.currentDataSource.length);        
        this.setState({ pagination: pagination, highlightedRowID: 0, totalRowCount : extra.currentDataSource.length});
    }

    //Message box confirm delete click
    onConfirmDelete = (value) => {
        //console.log('reached in delete:  ', value);
        this.setState({ showMessageBox: false });
        this.deletePost(value);
    }

    closeMessageBox(value = false) {
        this.setState({ showMessageBox: value });
    }

    // Add new record click
    onAddNewRecordClick(modelToggle) {
        this.setState({ showModel: modelToggle, rowData: {} });
    }

    hideModelWindow() {
        this.setState({ showModel: false, rowData: {}, categoryError: '', degreeError: '' });
    }

    onTextChange = ({ target: { name, value } }) => {
        if (name == 'Qualification_Name' && value.length > 50)
            return;

        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [name]: value }
        });

        //this.setState({ [name]: value.trim() });
    }

    onCategoryChange = (event) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [event.target.name]: event.target.value }
        });
    }

    validateFormData = () => {
        let body = this.state.rowData;

        this.setState({
            categoryError: '',
            degreeError: ''
        });

        //console.log("Validate: ", body);
        let hasError = false;

        if (!body.Qualification_Name || !body.Qualification_Name.trim()) {
            this.setState({ categoryError: 'Please enter valid Specialization Name' });
            hasError = true
        }

        if (!body.ParentId) {
            this.setState({ degreeError: 'Please select Degree' });
            hasError = true
        }

        return hasError;
    }

    render() {        
        const TableColumns = [
            {
                title: 'Specialization Name',
                dataIndex: 'Qualification_Name',
                filterSearch: true,
                width: '55%',
                key: 'Qualification_Name',
                sorter: (a, b) => a.Qualification_Name.localeCompare(b.Qualification_Name),
            },
            {
                title: 'Degree Name',
                dataIndex: 'Parent_Qualification_Name',
                filterSearch: true,
                width: '25%',
                key: 'Parent_Qualification_Name',
                sorter: (a, b) => a.Parent_Qualification_Name.length - b.Parent_Qualification_Name.length,
                filters: this.state.degree ? this.state.degree.map(item => ({ text: item.Name, value: item.Name })) : [],
                onFilter: (value, record) => record.Parent_Qualification_Name.indexOf(value) === 0,
            },
            {
                title: 'Action',
                dataIndex: '',
                key: 'Id',
                render: (value) => {
                    return (
                        <>
                            <ButtonComponent type="button" value="Edit" className="button-global button-border small autoHeight mr-2" onClick={(event) => this.onEditClick(value)} />
                            <ButtonComponent type="button" value="Delete" className="button-global button-danger small autoHeight" onClick={(event) => this.onDeleteClick(value)} />
                        </>
                    );
                }
            },
        ];

        if (this.state.loading)
            return <LoadingSpinner />

        return (

                <div className="container-fluid p-3">
                    <PageHeader
                        title="Specialization Master"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Specialization Master' }]}
                    />
                    <div className="analysisWrap">
                            <div style={{ textAlign: 'right' }}>
                                {!this.state.showModel &&
                                    <div className="max1200 m-auto mb-2"> 
                                        <div className="d-flex align-items-center justify-content-end">
                                            <a className="button-global button-border addbutton autoWidth d-inline-block text-center autoHeight mb-3 mr-2 d-flex align-items-center justify-content-center" 
                                            onClick={() => this.onAddNewRecordClick(true)}><Icon type="plus-circle" className="mr-2 font1rem" /> Add Specialization</a>
                                
                                        </div>
                                    </div>  
                                }
                            </div>
                            {this.state.showModel &&    
                            <div className="max1200 m-auto">
                                <div className="ent-panel">
                                    <h4 className="heading4">{this.state.rowData ? this.state.rowData.Id > 0 ? "Update" : "Add" : "Add"} Specialization </h4>
                                    <div className="admin-inner-wrap p-3">  
                                        <div className="row flex-sm-row ">
                                            <div className="mb-2 col-sm-4">
                                                <MyInput id="Qualification_Name"
                                                    type="text"
                                                    key="Qualification_Name"
                                                    name="Qualification_Name"
                                                    heading="Specialization Name"
                                                    value={this.state.rowData.Qualification_Name ? this.state.rowData.Qualification_Name : ""}
                                                    onChange={this.onTextChange}
                                                    isRequired={true}
                                                    errorState={this.state.categoryError}
                                                    errorMessage={this.state.categoryError} />
                                            </div>
                                            <div className="col-sm-4">
                                                <DropdownList
                                                    value={this.state.rowData.ParentId ? this.state.rowData.ParentId : 0}
                                                    name="ParentId"
                                                    onChange={this.onCategoryChange}
                                                    placeholder="Select Degree"
                                                    heading={"Degree"}
                                                    className="w-100"
                                                    wrapClass="wrap"
                                                    isRequired={true}
                                                    options={this.state.degree}
                                                    errorState={this.state.degreeError}
                                                    errorMessage={this.state.degreeError}
                                                />
                                            </div>
                                        </div>    
                                    </div>  
                                    <div className="pt-4 buttonAlignCenter" >
                                        <ButtonComponent type="button" value="Cancel" onClick={() => this.hideModelWindow()} className="button-global button-secondary mr-4 autoHeight small" />
                                        <ButtonComponent type="button" value="Save" onClick={this.handleUpdate} className="button-global button-primary autoHeight small" disabled={this.state.loading} />
                                    </div>
                                </div>
                            </div>              
                            }  
                            <div className="max1200 m-auto">
                                <Table size='small'
                                    bordered
                                    rowKey='Id'
                                    columns={TableColumns}
                                    dataSource={this.state.data}
                                    pagination={this.state.pagination}
                                    footer={() => <label style={{ textAlign: 'right', marginRight: '20px' }}>Total Records: {this.state.totalRowCount}</label>}
                                    onChange={this.onTableAction}
                                    rowClassName={(record, index) => (index % 2 ? 'odd' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : '') :
                                        'even' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : ''))}
                                    className="table-striped-rows admin-table"
                                    locale={{ emptyText: <EmptyState icon="inbox" title="No Records Found" description="No specializations have been added yet." /> }}
                                />
                            </div>  
                    </div>
                    <Modal
                        centered={true}
                        width={400}
                        // bodyStyle={{
                        //     height: "150px",
                        //     padding: 0,
                        //     alignItems: "center",
                        //     justifyContent: "center",
                        //     display: " flex"
                        // }}
                        className="modelPopAnt admin-home"
                        visible={this.state.showMessageBox}
                        onCancel={() => this.closeMessageBox(false)}
                        footer={false}
                    >
                        <ConfirmPopup
                            onCancel={() => this.closeMessageBox(false)}
                            onOk={this.onConfirmDelete}
                            popupData={this.state.rowData}
                            message="Are you sure, you want to delete this Specialization?"
                        />
                    </Modal>
                </div>

                
        )
    };
}

export default SpecializationMaster;